export default __webpack_public_path__ + "static/media/OpenSans-Bold.08328bf7.woff";